export const referenceMain = {
    'legend-chart': {
        tooltip: "{count} patient | {count} patient | {count} patients",
        name: "Nombre",
        title: "patients"
    },
    title: "Meilleures références",
    loading: "Chargement en cours…",
    'chart-title': "Les meilleures manières de vous référencer",
}